import React, { useContext, useEffect, useState } from 'react'
import { HorizontalLayout, VerticalLayout } from "./layout"
import { SettingsHeader } from "../molecule/settingsHeader"
import { StandardComp } from "../atoms/standardComp"
import { TitleDescriptionText } from "../atoms/titleDescription"
import { ToastContext, UserContext } from "../App"
import { postAPI, updateAPI } from "../api/api"

export default function AppModusSettings() {
    const userContext = useContext(UserContext);
    const toastContext = useContext(ToastContext);
    const [selectedMode, setSelectedMode] = useState(userContext.account_type)
    console.log("context,", userContext)
    const settingsOptions = [
        {
        id: 0,
        title: "Interne modus",
        description: "Alleen voor medewerkers binnen de organisatie.",
        },
        {
        id: 1,
        title: "Externe modus",
        description: "Voor klanten en externe partners.",
        },
  ];
  const ChangeModus = async (id) => {
    const selected = settingsOptions.find((opt) => opt.id === id);
    if (selectedMode === id) {return toastContext.showToast(`Je hebt al het platform ingesteld op "${selected.title}".`, "info" );}
    const query = "api/users/change-modus"
    const body = {modus: id}
    const res = await updateAPI(query, body);
    console.log("resultad", res)
    if(res.status ==="ok"){
        setSelectedMode(id);
        toastContext.showToast(<>Het platform is nu ingesteld op {selected.title}.</>, "success");
        window.location.reload();
    }
  }
  return (
    <VerticalLayout className="settings-card">
        <SettingsHeader button={false} title={"Modus"} description={"Bepaal of het platform in interne of externe modus wordt gebruikt."} />
        <VerticalLayout style={{ width: "auto", gap: "1rem", }} className="standard-margin">
            {settingsOptions.map((option) => (
                <StandardComp onClick={() => ChangeModus(option.id)} style={{ width: "25%", marginRight: "0"}} key={option.id} content={
                    <> 
                    <HorizontalLayout style={{ gap: "1.5rem", }}>
                        <input
                            type="radio"
                            id={`mode-${option.id}`}
                            name="platform-mode"
                            checked={selectedMode === option.id}
                            onChange={() => ChangeModus(option.id)}
                            style={{width: "unset", transform: "scale(1.5)"}}
                        />
                        <TitleDescriptionText className={"modus-page-title"} style={{ margin: "0", padding: "0", }} title={option.title} description={option.description} />
                    </HorizontalLayout>
                    </>
                } />
              ))}
        </VerticalLayout>
    </VerticalLayout>
  )
}
